import { formatDatePast } from '@spotify/confidence-core-react';
import { PlanningDataFragment } from '@spotify/confidence-graphql';

import { usePlanningDates } from '../usePlanningDates';

export function usePlanningSubtitle(
  planning?: PlanningDataFragment | null,
): string | null {
  const { actualStartDate, actualEndDate } = usePlanningDates(planning);

  if (actualEndDate) {
    return `Ended ${formatDatePast(actualEndDate)}`;
  }

  if (actualStartDate) {
    return `Launched ${formatDatePast(actualStartDate)}`;
  }

  return null;
}
